import React from "react";
import { useParams } from "react-router-dom";

const Player = () => {
  const params = useParams();
  return (
    <div className="video-player bg-slate-800">
      <iframe
        width="800"
        height="500"
        src={`https://www.youtube.com/embed/${params.id}`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        title="YouTube video player"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Player;
